import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import jwtDecode from 'jwt-decode';

interface RoleGuardProps {
  roles: string[];
  children: ReactNode;
}

const RoleGuard: FC<RoleGuardProps> = ({ roles, children }) => {
  const decoded: any = jwtDecode(localStorage.getItem('accessToken'));
  const userRoles: string[] = decoded?.realm_access?.roles ?? [];
  const hasRole = roles.some((r) => userRoles.includes(r));

  if (!hasRole) {
    return <Navigate to="/admin/not-found" />;
  }

  return <>{children}</>;
};

export default RoleGuard;
